var moment = require("moment");
var RepositoryAPI = require("../../../../common/api/repository");

module.exports = function($scope, event) {
  $scope.event = event || {};
  $scope.event.image = {
    id: $scope.event.imageId,
    fileName: $scope.event.imageId ? "eventImage.png" : null
  }
  $scope.$watch("event.image", function(newEventImage) {
    $scope.event.imageId = (newEventImage || {}).id
  });


  $scope.submit = function() {
    $scope.closeThisDialog({ action: "submit", event: $scope.event });
  };
  $scope.cancel = function() {
    $scope.closeThisDialog({ action: "cancel" });
  };
  $scope.delete = function () {
    $scope.closeThisDialog({ action: "delete", event: $scope.event});
  };
};
